import React, { useState } from 'react';
import { Avatar } from './Avatar';
import { EmployeeAvatarGroup } from './EmployeeAvatarGroup';
import { AssignedUsersModal } from '../modals/AssignedUsersModal';

export const ChatHeader = ({
  conversation,
  onBack,
  currentUser,
  onOpenAssign,
  onUpdateStatus,
  onClickCustomerInfo
}) => {
  const [isAssignedUsersModalOpen, setIsAssignedUsersModalOpen] = useState(false);

  const customerName = conversation.customerName !== 'Unknown'
    ? conversation.customerName
    : conversation.customerPhone;

  const isOwnerOrAdmin = ['owner', 'admin', 'superadmin'].includes((currentUser?.role || '').toLowerCase());

  return (
    <>
      <div className="bg-white border-b border-gray-200 px-4 md:px-6 py-4 flex flex-col md:flex-row md:justify-between md:items-center z-10 shadow-sm gap-4">
        <div className="flex items-center gap-4">
          <button
            onClick={onBack}
            className="md:hidden p-2 -ml-2 text-gray-600 hover:bg-gray-100 rounded-full transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
          </button>

          <button
            onClick={onClickCustomerInfo}
            className="flex items-center gap-4 hover:bg-gray-50 p-2 -ml-2 rounded-xl transition-colors text-left"
          >
            <Avatar name={customerName} size="lg" active={conversation.status === 'open'} />

            <div>
              <h3 className="text-lg font-bold text-gray-900 tracking-tight leading-none mb-1 group-hover:text-purple-700 transition-colors">
                {customerName}
              </h3>
              <p className="text-sm text-gray-500 font-medium">
                {conversation.customerPhone}
              </p>
            </div>
          </button>
        </div>

        <div className="flex items-center gap-4 self-end md:self-auto">
          {Array.isArray(conversation.assignedTo) && conversation.assignedTo.length > 0 && (
            <div className="flex items-center gap-3 bg-gray-50 px-3 py-1.5 rounded-full border border-gray-100">
              <span className="hidden lg:inline-block text-xs font-medium text-gray-500 uppercase tracking-wider">
                Assigned
              </span>
              <EmployeeAvatarGroup
                employees={conversation.assignedTo}
                onClick={() => setIsAssignedUsersModalOpen(true)}
              />
            </div>
          )}

          {isOwnerOrAdmin && (
            <button
              onClick={onOpenAssign}
              className="text-sm bg-purple-100 hover:bg-purple-200 text-purple-700 px-4 py-2 rounded-lg transition-colors font-semibold shadow-sm"
            >
              Assign
            </button>
          )}

          <button
            onClick={() => onUpdateStatus(conversation._id, conversation.status === 'resolved' ? 'open' : 'resolved')}
            className={`text-sm px-4 py-2 rounded-lg transition-colors font-semibold shadow-sm ${
              conversation.status === 'resolved'
                ? 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                : 'bg-green-100 hover:bg-green-200 text-green-700'
            }`}
          >
            {conversation.status === 'resolved' ? 'Reopen Deal' : 'Close Deal'}
          </button>
        </div>
      </div>

      <AssignedUsersModal
        isOpen={isAssignedUsersModalOpen}
        onClose={() => setIsAssignedUsersModalOpen(false)}
        assignedTo={conversation.assignedTo}
      />
    </>
  );
};
